<template>
	<Container>
		<div class="container">
			<p class="title">搜索<strong>“{{keys}}”</strong>共找到{{result.TotalCount-searchedProductLength+productsLength ||0}}种结果</p>
			<div class="tabs">
				<div class="tab" :class='{"active-tab":qw == "Product"}' @click='qw = "Product"'>产品({{productsLength}})</div>
				<div class="tab" :class='{"active-tab":qw == "Article"}' @click='qw = "Article"'>其他({{articlesLength}})</div>
				<div class="tab" :class='{"active-tab":qw == "All"}' @click='qw = "All"'>全部({{result.TotalCount-searchedProductLength+productsLength || 0}})</div>
			</div>
			<loading v-if='loading'/>
			<div class="result" v-else>
				<template v-for='modular in result.Datas'>
					<template v-if='modular.Code == "Product" && (qw =="All" || qw == "Product")'>
						<p class="tab-name">{{modular.Title}}({{productsLength}})</p>
						<ul class="products" >
							<ProductCell :marighLeft='1.5' :goodsWidth='goodsWidth' class='product' v-for='(item,i) in products' :product='item' :key="i" @showSurveyfun='showSurveyfun' @showPromoCode='showPromoCode' :firstOrder='isFirstOrder'/>
						</ul>
						<LoadMore v-lazyFunc='searchMoreProduct' v-if='productsLoading'/>
					</template>
					<template v-if='modular.Code == "Article" && (qw =="All" || qw == "Article")'>
						<p class="tab-name">{{modular.Title}}({{articlesLength}})</p>
						<div class="articles" >
							<div class="item" v-for='article in modular.Datas'>
								<p class="title">{{article.Title}}</p>
								<p class="datetime">{{article.ValidFrom | dateFormat}}</p>
								<p class="content">{{article.Content | noHTML}}</p>
								<a :href='article.Href' class="button-primary detail">{{article.Flag2 || '查看详情'}}</a>
							</div>
							<LoadMore v-lazyFunc='searchMoreArticle' v-if='articlesLoading'/>
						</div>
					</template>
					
				</template>
			</div>
		</div>
		<orderSurvey :model="survey" :value='showSurvey' @showSurveyfun='showSurveyfun' />
		<PromoCode :products='PromoModel' :show='PromoModelShow' @showPromoCode='showPromoCode'></PromoCode>
	</Container>
</template>

<script>
	import ProductCell from '@/components/order/ProductCell'
	import loading from '@/components/order/loading'
	import orderSurvey from "@/components/order/orderSurvey";
	import PromoCode from "@/components/order/PromoCode";
	import {
		userInfoOrderMethods,
		promoCodeMethods
	} from "@/components/common/mixin";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				result:[],
				keys:'',
				qw:'Product',
				articlePageIndex:1,
				productPageIndex:1,
				loading:true,
				articlesLoading:true,
				productsLoading:true,
				pageSize:10,
				showSurvey: false,
				survey: null,
				PromoModel: null,
				PromoModelShow: false,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				let keys = value.query?.keys
				this.search(keys)
			},
		},
		mixins:[userInfoOrderMethods,promoCodeMethods],
		components: {
			ProductCell,
			loading,
			orderSurvey,
			PromoCode,
		},
		computed: {
			...mapGetters([
				"getUserId",
			]),
			...mapState({
				sysConfig: state => state.common.sysConfig,
				productInfo: state => state.order.productInfo,
				productStockInfo: state => state.order.productStockInfo,
				warehouseInfo: state => state.order.warehouseInfo,
				userInfo: state => state.common.wechatUserInfo,
				guestInfo: state => state.common.guestInfo,
				forCustomer: state => state.order.forCustomer,
				isBuy: state => state.lrporder.isBuy,
				promote: state => state.order.promote,
				productLimt: state => state.order.productLimt,
				newpromoCode: state => state.order.newpromoCode
			}),
			//需要隐藏的产品
			hiddenSKUs:function(){
				let skus = {}
				let limits = [...((this.productLimt || {}).value || [])]
		      limits.filter((u) => u.limit_type == 'Visibility' && u.max_num <= 0).forEach(item=>skus[item.sku] = 1)
		      return skus
		    },
			warehouseList: function() {
				return [...((this.warehouseInfo || {}).value || [])];
			},
			productStock: function() {
				let ret = [...((this.productStockInfo || {}).value || [])];
				return ret;
			},
			searchedProductLength(){
				return this.result?.Datas?.filter(item=>item.Code == 'Product')[0]?.TotalCount || 0;
			},
			productsLength(){
				return this.products.length || 0;
			},
			articlesLength(){
				return this.result?.Datas?.filter(item=>item.Code == 'Article')[0]?.TotalCount || 0;
			},
			goodsWidth(){
				if (document.body.clientWidth <= 768) {
					return 45
				}
				return 18
			},
			products(){
				let showProducts = []
				let products = this.productInfo.value.map(item=>item.products).flatMap(item=>item)
				let searched = this.result?.Datas?.filter(item=>item.Code == 'Product')[0]?.Datas || []
				searched.forEach(item=>{
					for (let item1 of products) {
						if(item1.sku == item.Code) {
							showProducts.push(item1)
							break;
						}
					}
				})
				var FirstOrder = this.isFirstOrder;
				let catalog = this.newcustomer;
				let isBuy = this.isBuy;
				showProducts.forEach((product, i2, productList)=>{
					let sku = product.sku;
					// let code = item.code && item.code.toLowerCase();
					// if (code == "first order" && FirstOrder) {
					// 	product.first_order = true;
					// }
					// if (product.is_lrpt_product != 0 && notsku[sku]) {
					// 	product.control = 20;
					// 	result=true;
					// } else {
						let is_inventory = product.is_inventory;
						if (
							is_inventory == 1 ||
							(is_inventory == 10 &&
								this.default_store_id == "501")
						) {
							product.control = -1; //未查询到库存信息
							product.stock = 0;
							this.productStock.forEach(
								(warehouse, index1) => {
									if (
										this.default_store_id ==
										warehouse.warehouse
									) {
										warehouse.stock.forEach(
											(stock, index2) => {
												let control = stock.control;
												if (stock.sku == sku) {
													// result = true;
													if (stock.stock <= 0) {
														product.control = control;
													} else {
														product.control = 2; //有库存，可以销售
													}
													product.stock =
														stock.stock;
												}
											}
										);
									}
								}
							);
						} else if (is_inventory == 10) {
							product.control = -1;
						} else {
							product.control = 10; //不判断库存，任意销售
							product.stock = 999999999;
						}
					// }

					productList[i2] = product;
				})
				return showProducts.filter(item=>!this.hiddenSKUs[item.sku])
			}
		},
		methods: {
			...mapActions([
				'searchByKeysAction',
				'initProductAction',
				'initProductLimtAction',
				'initProductStock',
				'initWarehouseAction',
				'getAccountBalanceAction',
				'initPromoteAction',
				'checkBirthdaySuitAction',
			]),
			...mapMutations([
				'SET_PTBALANCE',
				'SET_BIRTHDAYLIMT',
			]),
			async search(keys){
				this.keys = keys
				this.loading = true
				this.result = {}
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:this.qw,
					startIndex:1,
					pageSize:this.pageSize,
					isCount:10,
				})
				this.result = response
				this.loading = false
				this.articlePageIndex = 1
				this.productPageIndex = 1
				this.productsLoading = true
				this.articlesLoading = true
			},
			async initData(){
				await this.initWarehouseAction();
				await this.initProductStock(this.default_store_id);
				await this.initProductAction();
				await this.initProductLimtAction();
				await this.initPromoteAction(true);
				this.checkBirthdaySuit()
				this.keys = this.$route.query?.keys
				this.loading = true
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:'All',
					startIndex:1,
					pageSize:this.pageSize,
					isCount:10,
				})
				this.result = response
				this.loading = false
			},
			async checkBirthdaySuit() {
				this.SET_BIRTHDAYLIMT(-1);
				if (!this.getUserId) return;

				var birthday = this.userInfo.value.binding.register.birthday;
				var now_time = this.sysConfig.value.now_time;
				if (isNaN(birthday)) {
					var arr = birthday.split(/[- : \/]/);
					var birthday_date = new Date(
						arr[0],
						arr[1] - 1,
						arr[2],
						arr[3],
						arr[4],
						arr[5]
					);
					var arr1 = now_time.split(/[- : \/]/);
					var now_time_date = new Date(
						arr1[0],
						arr1[1] - 1,
						arr1[2],
						arr1[3],
						arr1[4],
						arr1[5]
					);
					if (birthday_date.getMonth() == now_time_date.getMonth()) {
						var res = await this.checkBirthdaySuitAction(
							this.userInfo.value.binding.user_id
						);
						if (res) {
							if (res.v == 1) {
								this.SET_BIRTHDAYLIMT(1);
							} else {
								this.SET_BIRTHDAYLIMT(0);
							}
						}
					}
				}
			},
			async getAccountBalance() {
				let res = await this.getAccountBalanceAction();
				if (res && res[0]) {
					var points = res.filter((u) => u.type == "PT");
					if (points[0]) {
						this.SET_PTBALANCE(points[0].val)
					}
				}
			},
			async searchMoreArticle(){
				this.articlePageIndex += this.pageSize;
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:'Article',
					startIndex:this.articlePageIndex,
					pageSize:this.pageSize,
					isCount:0,
				})
				this.articlesLoading = false
				let articles = this.result.Datas?.filter(item=>item.Code == 'Article')[0]?.Datas
				let newArticles = response?.Datas[0]?.Datas || []
				articles = [...articles,...newArticles]
				this.result.Datas.filter(item=>item.Code == 'Article')[0].Datas = articles
				if (this.articlePageIndex  <= this.articlesLength) {
					setTimeout(()=>{
						this.articlesLoading = true
					}, 500)
				}
				
			},
			async searchMoreProduct(){
				this.productPageIndex += this.pageSize;
				let response = await this.searchByKeysAction({
					keys:this.keys,
					QW:'Product',
					startIndex:this.productPageIndex,
					pageSize:this.pageSize,
					isCount:0,
				})
				this.productsLoading = false
				let articles = this.result.Datas?.filter(item=>item.Code == 'Product')[0]?.Datas
				let newArticles = response?.Datas[0]?.Datas || []
				articles = [...articles,...newArticles]
				this.result.Datas.filter(item=>item.Code == 'Product')[0].Datas = articles
				if (this.productPageIndex <= this.searchedProductLength) {
					setTimeout(()=>{
						this.productsLoading = true
					}, 500)
				}
				
			},
			showSurveyfun(model){
				if (model) {
					this.survey = model;
				}
				
				this.showSurvey = !this.showSurvey;
			},
			showPromoCode(products) {
				if (products) {
					this.PromoModel = products;
				}
				this.PromoModelShow = !this.PromoModelShow;
			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.container {
		width: 85%;
		margin: auto;
		padding-top:0;
	}
	.title {
		text-align: center;
		@include fontSize($font-size-20);
		margin:40px 0;
		font-weight: bold;
		strong {
			@include fontSize($font-size-24);
			padding: 0 10px;
			font-weight: normal;
		}
	}
	.tabs {
		display:flex;
		align-items: center;
		justify-content: space-around;
		border-bottom:1px solid #eee;
		.tab {
			@include fontSize($font-size-24);
			padding: 10px 20px;
			cursor: pointer;
		}
		.active-tab {
			border-bottom:1px solid $theme-color;
			color:$theme-color;
		}
	}
	.result {
		.tab-name {
			@include fontSize($font-size-20);
			margin: 20px 0;
		}
		.products {
			list-style: none;
			display:flex;
			align-items: center;
			flex-wrap: wrap;
			.product {
				margin-left: 10px;
			}
		}
		.articles {
			.item {
				margin:0 20px;
				border-bottom: 1px solid #eee;
				.title {
					color:$theme-color;
					@include fontSize($font-size-18);
					margin-bottom: 5px;
					text-align: left;
					font-weight: normal;
				}
				.datetime,.content {
					margin-bottom: 5px;
				}
				.datetime {
					// max-width: 100px;
				}
				.detail {
					display: inline-block;
					padding: 3px 10px;
					border-radius: 20px;
					margin-top: 20px;
					margin-bottom: 20px;
				}
			}
		}
	}
	@media (max-width: 768px){
		.container {
			width: 95%;
		}
	}
</style>